import React from 'react';
import { AiOutlineCheckCircle, AiOutlineClose } from 'react-icons/ai';

const ExamSubmittedPopup = ({ onClose }) => {
    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="relative w-[90%] max-w-md bg-white rounded-xl shadow-lg px-6 py-8 text-center">
                {/* Close Icon */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
                    aria-label="Close"
                >
                    <AiOutlineClose size={20} />
                </button>

                {/* Success Icon */}
                <div className="mx-auto mb-4 flex justify-center">
                    <AiOutlineCheckCircle className="text-green-500 text-5xl" />
                </div>

                {/* Title */}
                <h3 className="text-2xl font-bold text-gray-800 mb-3">
                    Candidate has already submitted exam.
                </h3>

                {/* Message */}
                <p className="text-gray-600 mb-6">
                    Your exam has already been submitted and is being processed.
                </p>

            </div>
        </div>
    );
};

export default ExamSubmittedPopup;